module.exports = __webpack_public_path__ + "static/media/header-ptm.5b2ed3f9.png";